import { frontendURL } from '../../../helper/URLHelper';
import KanbanIndex from './pages/KanbanIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    component: KanbanIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'kanban_dashboard_index',
        component: KanbanIndex,
        meta: commonMeta,
      },
    ],
  },
];
